import {
  getReservationConditions,
  getTargetTimeLabel,
} from '@lp/features/AssignmentTables/components/ReservationCondition/utils';
import { CandidateMatchType, EmployeeAssignmentCandidateMatch } from '@/api/apis/resources';
import { Unavailability } from '@/api/apis/resources/schedule';

export type WarningResourceType = 'cs' | 'rs';

export const formatWarningMessage = (
  targetTime: string,
  resourceType: WarningResourceType,
  employeeFullName: string,
  match: EmployeeAssignmentCandidateMatch,
  onCallBeforeTargetMinutes?: number | null,
  onCallAfterTargetMinutes?: number | null,
  onRestStartsAfterTargetMinutes?: number | null,
  onRestEndsBeforeTargetMinutes?: number | null,
  unavailabilities?: Unavailability[],
  showGoTime?: boolean,
) => {
  const isCS = resourceType === 'cs';
  const resource = isCS ? 'Clinical Specialist' : 'Retrieval Surgeon';
  const timeString = getTargetTimeLabel(showGoTime, targetTime);
  const conditions = getReservationConditions(
    match,
    onCallBeforeTargetMinutes,
    onCallAfterTargetMinutes,
    onRestStartsAfterTargetMinutes,
    onRestEndsBeforeTargetMinutes,
    unavailabilities,
    targetTime,
    showGoTime,
  );
  const makeSureText =
    match.onRestMatchType === CandidateMatchType.Medium
      ? 'Make sure this is enough time to prepare for deployment.'
      : "Make sure it's enough time to deploy.";
  return `${resource} ${employeeFullName}: ${timeString} ${conditions.join(' ')} ${makeSureText}`;
};
